import jwt_decode from 'jwt-decode'

const isInterimAccessToken = (accessToken: string) => {
  const decoded = jwt_decode(accessToken) as any

  return !!(decoded && !decoded['https://babylonhealth.com/user'])
}

export default isInterimAccessToken
